module.exports = __webpack_public_path__ + "img/on-hold-3zDbD8m.svg";